/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';

angular.module('bulbApp.assetLibraryModule')
.directive('bulbAssetlibraryAddAudioPane', bulbAssetlibraryAddAudioPane);

function bulbAssetlibraryAddAudioPane() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'ajs/assetlibrary/modal/add-audio-pane.html',
    controllerAs: 'addAudioPaneCtrl',
    controller: function(){
      this.assetContainerCtrl = null;
    },
    link: function(scope, element, attrs, addAudioPaneCtrl) {
      addAudioPaneCtrl.assetContainerCtrl = scope.assetContainerCtrl;
      scope.selectionModal = attrs.selectionModal;
    }
  };
}
